<template>
	<div id="admin-content-container" class="p-3 container-fluid">
		<div class="card" style="overflow-y: auto;">
			<div class="card-header">
				<h5 class="mb-0 card-title">{{ __('translations.title.import_from_iiif') }}</h5>
			</div>
			<div class="card-body">
				<div v-if="success" class="alert alert-success alert-dismissible fade show">
					{{ __('translations.message.import_message') }}
					<button type="button" class="close" data-dismiss="alert" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<form @submit.prevent="importFromIiif">
					<div class="form-group">
						<label class="form-label">{{ __('translations.label.collection_type')}}</label>
				       	<div class="pr-0">
				           	<select v-if="collectionTypes.length > 0" class="custom-select" name="collection" id="collection" v-model="selectedCollectionType">
				        		<option v-for="ct in collectionTypes" :value="ct.collection_typcode" :key="ct.collection_typcode">{{ ct.description }}</option>
				        	</select>
				       	</div>
				   	</div>
					<div class="form-group">
					    <label for="exampleFormControlInput1">{{ __('translations.label.iiif_url')}}</label>
					    <input type="url" class="form-control" v-model="iiifUrl" id="exampleFormControlInput1">
					    <div v-if="errors && errors.iiifUrl" class="text-danger"><small>{{ errors.iiifUrl[0] }}</small></div>
					</div>
					<button type="submit" class="btn btn-primary">{{ __('translations.button.import') }}</button>
				</form>
		  	</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			selectedCollectionType: '',
			collectionTypes: [],
			iiifUrl: null,
			success: false,
			errors: {},
		}
	},
	watch: {
		collectionTypes: {
			handler: function (values) {
				if(values.length > 0) {
					this.selectedCollectionType = values[0].collection_typcode;
				}
            }
		},
	},
	mounted() {
		axios.get('/fetchCollectionTypes').then(response => {
        	this.collectionTypes = response.data;
        }).catch(err => {
            console.log(err)
        })
	},
	methods: {
		importFromIiif() {
			this.errors = {};
			
			axios.post('/importFromIiif', {iiifUrl: this.iiifUrl, collectionType: this.selectedCollectionType}).then(response => {
				this.success = true;
	        }).catch(err => {
	        	if (err.response.status === 422) {
					this.errors = err.response.data.errors || {};
				} else if (err.response.status === 400) {
					console.log(err);
					this.warning = true;
				}
	        })
		},
	}
}
</script>